(function () {
  'use strict';
  if (window.PedalInsidersCartSize) return;
  window.PedalInsidersCartSize = 1;

  var ERR_GENERIC = "Couldn't change the size. Your original size is still in your cart.";
  var ERR_DUPLICATE = 'That size is already in your cart.';

  function swapMap() {
    try { return JSON.parse(localStorage.getItem('insCartSwaps') || '{}'); }
    catch (e) { return {}; }
  }

  function recordSwap(fromId, toId) {
    try {
      var map = swapMap();
      Object.keys(map).forEach(function (k) {
        if (map[k] === fromId) map[k] = toId;
      });
      map[fromId] = toId;
      delete map[toId];
      var keys = Object.keys(map);
      if (keys.length > 50) {
        keys.slice(0, keys.length - 50).forEach(function (k) { delete map[k]; });
      }
      localStorage.setItem('insCartSwaps', JSON.stringify(map));
    } catch (e) {}
  }

  var cartWrites = [];
  (function () {
    var base = window.fetch;
    if (!base) return;
    window.fetch = function (input, init) {
      var p = base.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        var done = p.then(function () {}, function () {});
        cartWrites.push(done);
        done.then(function () {
          var i = cartWrites.indexOf(done);
          if (i > -1) cartWrites.splice(i, 1);
        });
      }
      return p;
    };
  })();

  function settled(round) {
    round = round || 0;
    if (!cartWrites.length || round >= 5) return Promise.resolve();
    return Promise.all(cartWrites.slice()).then(function () { return settled(round + 1); });
  }

  function cartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (c) {
      if (!c || !c.items) throw new Error('cart unreadable');
      return c;
    });
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function cartUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function cartAdd(item) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function linePayload(line, variantId) {
    var payload = { id: variantId, quantity: line.quantity, properties: line.properties || {} };
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
      payload.selling_plan = line.selling_plan_allocation.selling_plan.id;
    }
    return payload;
  }

  function setAllDisabled(disabled) {
    document.querySelectorAll('[data-ins-size]').forEach(function (el) { el.disabled = disabled; });
  }

  function errEl(select) {
    var wrap = select.closest('.cart__item') || select.parentElement;
    return wrap ? wrap.querySelector('[data-ins-size-err]') : null;
  }

  function showError(select, message) {
    var el = errEl(select);
    if (el) { el.textContent = message; el.hidden = false; }
  }

  var pendingError = null;
  var errorWatch = null;

  function paintPendingError() {
    if (!pendingError) return;
    document.querySelectorAll('[data-ins-size]').forEach(function (sel) {
      if (Number(sel.getAttribute('data-variant-id')) !== pendingError.variantId) return;
      var el = errEl(sel);
      if (el && (el.hidden || el.textContent !== pendingError.message)) showError(sel, pendingError.message);
    });
  }

  function keepError(select, variantId, message) {
    showError(select, message);
    pendingError = { variantId: Number(variantId), message: message };
    paintPendingError();
    if (!errorWatch && window.MutationObserver) {
      errorWatch = new MutationObserver(paintPendingError);
      errorWatch.observe(document.body, { childList: true, subtree: true });
    }
  }

  function clearError(select) {
    pendingError = null;
    if (errorWatch) { errorWatch.disconnect(); errorWatch = null; }
    var el = errEl(select);
    if (el) el.hidden = true;
  }

  function resetSelect(select) {
    var original = select.getAttribute('data-variant-id');
    if (original) select.value = original;
  }

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  }

  function elevarProduct(line) {
    return {
      id: String(line.product_id),
      product_id: String(line.product_id),
      variant_id: String(line.variant_id),
      name: line.product_title || '',
      variant: line.variant_title || '',
      price: (Number(line.price || 0) / 100).toFixed(2),
      quantity: String(line.quantity || 1),
      sku: line.sku || '',
      handle: line.handle || ''
    };
  }

  function pushElevar(event, key, line) {
    if (!line) return;
    window.ElevarDataLayer = window.ElevarDataLayer || [];
    var payload = { actionField: { list: 'Cart' }, products: [elevarProduct(line)] };
    var ecommerce = { currencyCode: currency() };
    ecommerce[key] = payload;
    window.ElevarDataLayer.push({ event: event, ecommerce: ecommerce });
  }

  function finishSuccess(oldLine, targetId) {
    recordSwap(oldLine.variant_id, targetId);
    pushElevar('dl_remove_from_cart', 'remove', oldLine);
    return cartJson().then(function (cart) {
      var newLine = (cart.items || []).filter(function (i) { return i.variant_id === targetId; })[0];
      pushElevar('dl_add_to_cart', 'add', newLine);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }, function () {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }

  function converge(oldLine, targetId, pass) {
    var next = function () { return converge(oldLine, targetId, pass + 1); };
    return settled().then(cartJson).then(function (cart) {
      var items = cart.items || [];
      var olds = items.filter(function (i) { return i.variant_id === oldLine.variant_id; });
      var targets = items.filter(function (i) { return i.variant_id === targetId; });
      if (olds.length && !targets.length) return 'kept';
      if (!olds.length && targets.length === 1) return 'swapped';
      if (pass >= 3) return 'unresolved';
      if (olds.length && targets.length) {
        var updates = {};
        targets.forEach(function (t) { updates[t.key] = 0; });
        return cartUpdate(updates).then(next, next);
      }
      if (targets.length > 1) {
        var extra = {};
        targets.slice(1).forEach(function (t) { extra[t.key] = 0; });
        return cartUpdate(extra).then(next, next);
      }
      return cartAdd(linePayload(oldLine, oldLine.variant_id)).then(next, next);
    }, function () {
      if (pass >= 3) return 'unresolved';
      return next();
    });
  }

  function settle(select, oldLine, targetId, failed) {
    if (failed) {
      resetSelect(select);
      keepError(select, oldLine.variant_id, ERR_GENERIC);
    }
    return converge(oldLine, targetId, 0).then(function (end) {
      if (end === 'swapped') {
        if (failed) clearError(select);
        return finishSuccess(oldLine, targetId);
      }
      resetSelect(select);
      keepError(select, oldLine.variant_id, ERR_GENERIC);
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }

  function planId(line) {
    return (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id) || null;
  }

  function sameProps(a, b) {
    var pa = a.properties || {};
    var pb = b.properties || {};
    var ka = Object.keys(pa).sort();
    var kb = Object.keys(pb).sort();
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) {
      if (ka[i] !== kb[i]) return false;
      if (JSON.stringify(pa[ka[i]]) !== JSON.stringify(pb[kb[i]])) return false;
    }
    return true;
  }

  function removeOld(oldLine, targetId, isRetry) {
    return settled().then(cartJson).then(function (cart) {
      var items = cart.items || [];
      var targetKeys = items.filter(function (i) { return i.variant_id === targetId; }).map(function (i) { return i.key; });
      var matches = items.filter(function (i) {
        return i.variant_id === oldLine.variant_id
          && i.variant_id !== targetId
          && targetKeys.indexOf(i.key) === -1
          && sameProps(i, oldLine)
          && planId(i) === planId(oldLine);
      });
      var pick;
      if (!matches.length) {
        return cart;
      } else if (matches.length === 1) {
        pick = matches[0];
      } else {
        pick = matches.filter(function (i) { return i.key === oldLine.key; })[0] || matches[0];
      }
      return cartChange(pick.key, 0).then(function (r) { if (!r.ok) throw new Error('remove failed'); return r.json(); });
    }).catch(function () {
      if (!isRetry) return removeOld(oldLine, targetId, true);
      return null;
    });
  }

  var busy = false;

  function onSwap(e) {
    var select = e.target;
    if (!select || !select.matches || !select.matches('[data-ins-size]')) return;
    if (busy) { resetSelect(select); return; }
    var lineKey = select.getAttribute('data-line-key');
    var targetId = Number(select.value);

    busy = true;
    clearError(select);
    setAllDisabled(true);

    cartJson().then(function (cart) {
      var items = cart.items || [];
      var line = items.filter(function (i) { return i.key === lineKey; })[0];
      if (!line) {
        keepError(select, select.getAttribute('data-variant-id'), ERR_GENERIC);
        document.dispatchEvent(new CustomEvent('cart:build'));
        return;
      }
      var already = items.filter(function (i) { return i.variant_id === targetId; })[0];
      if (already) {
        resetSelect(select);
        keepError(select, line.variant_id, ERR_DUPLICATE);
        return;
      }

      return cartAdd(linePayload(line, targetId))
        .then(function () { return removeOld(line, targetId, false); }, function () { return null; })
        .then(function (removed) { return settle(select, line, targetId, removed === null); });
    }).catch(function () {
      resetSelect(select);
      keepError(select, select.getAttribute('data-variant-id'), ERR_GENERIC);
    }).then(function () {
      busy = false;
      setAllDisabled(false);
    });
  }

  document.addEventListener('change', onSwap);
})();
